<template>
  <div class="form-container adminagency-form-container">
    <h1>行政機関の登録</h1>
    <form>
      <table class="admin-agency-register-table">
        <tbody>
          <!-- 地域 -->
          <tr>
            <td><label class="required-label">都道府県</label></td>
            <td><label>:</label></td>
            <td>
              <select v-model="region_id" class="form-control">
                <option value="" disabled>都道府県を選択してください</option>
                <option 
                  v-for="region in regions"
				  :value="region.region_id"
				  :key="region.region_id">
                  {{ region.region_id + ' ' + region.region_nm }}
                </option>
              </select>
            </td>
          </tr>

          <!-- 行政機関ID -->
          <tr>
            <td><label class="required-label">行政機関ID</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="newAdmin.gyouseiId" class="form-control" />
              <span v-if="errors.gyouseiId" class="error">{{ errors.gyouseiId }}</span>
            </td>
          </tr>
          <!-- 行政機関名 -->
          <tr>
            <td><label class="required-label">行政機関名</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="newAdmin.gyouseiName" class="form-control" />
              <span v-if="errors.gyouseiName" class="error">{{ errors.gyouseiName }}</span>
            </td>
          </tr>
          <!-- 行政機関ｶﾅ -->
          <tr>
            <td><label>行政機関ｶﾅ</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="newAdmin.kana" class="form-control" />
              <span v-if="errors.kana" class="error">{{ errors.kana }}</span>
            </td>
          </tr>
          <!-- 行政機関住所 -->
          <tr>
            <td><label>行政機関住所</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="newAdmin.gyouseiZyusho" class="form-control" />
              <span v-if="errors.gyouseiZyusho" class="error">{{ errors.gyouseiZyusho }}</span>
            </td>
          </tr>
          <!-- 担当部署 -->
          <tr>
            <td><label>担当部署</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="newAdmin.managerDepart" class="form-control" />
              <span v-if="errors.managerDepart" class="error">{{ errors.managerDepart }}</span>
            </td>
          </tr>
          <!-- 担当者名 -->
          <tr>
            <td><label>担当者名</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="newAdmin.managerName" class="form-control" />
              <span v-if="errors.managerName" class="error">{{ errors.managerName }}</span>
            </td>
          </tr>
          <!-- 電話番号 -->
          <tr>
            <td><label>電話番号</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="newAdmin.managerTell" class="form-control" />
              <span v-if="errors.managerTell" class="error">{{ errors.managerTell }}</span>
            </td>
          </tr>
          <!-- メール -->
          <tr>
            <td><label>メール</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="newAdmin.managerMail" class="form-control" />
              <span v-if="errors.managerMail" class="error">{{ errors.managerMail }}</span>
            </td>
          </tr>
        </tbody>
      </table>
  </form>
  <div class="button-container">
    <button type="button" @click="validateAndRegister" class="alert" :disabled="btnoff">登録</button>
  </div>
 </div>
</template>

<script>
import "@/assets/styles/AdminAgency.css";
import axios from 'axios'; // axiosをインポート
axios.defaults.timeout = process.env.VUE_TIMEOUT||5000;

export default {
  data() {
    return {
	  btnoff: true,
      regions: [],
	  region_id: '',
	  groups: [],
	  group_id: '',
      newAdmin: {
        region: '',
        gyouseiId: '',
        gyouseiName: '',
        managerDepart: '',
        managerName: '',
        managerTell: '',
        managerMail: '',
        gyouseiKbn: '市区町村',
        gyouseiZyusho: '',
        agencyIdCount: 0,
        agencyIdStatus: '無効',
        hunterIdCount: 0,
        hunterIdStatus: '無効',
        mieruAdminCount: 0,
        mieruAdminStatus: '無効',
        mieruMemberCount: 0,
        mieruMemberStatus: '無効',
        creatorId: '',
		kana: ''
      },
      errors: {}
    };
  },
  mounted() {
    this.getRegionDetails();
  },
  watch: {
	// 2026/04/01 Added by RFJ R.Komatsu
	region_id: async function() {
	  this.newAdmin.region = this.region_id;
	/***
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/app/FIX_municipality/prefecture/${this.region_id}`,
          { headers: { 'Content-Type': 'application/json' } }
        );
        this.groups = response.data;
		this.group_id = '';
      } catch (error) {
        alert("タイムアウトです、ログインしなおしてください");
        this.$router.push({ name: 'Login' });
      }
	***/
	  this.btnoff = false;
	},
	group_id: function() {
	  if (!this.group_id) return;

      this.newAdmin.gyouseiId = this.group_id;
	  var item = this.groups.find(c => c.code === this.group_id);
	  if (item.prefecture != item.name)
    	this.newAdmin.gyouseiName = item.prefecture + item.name;
	  else
    	this.newAdmin.gyouseiName = item.prefecture;
	  this.btnoff = false;
	},
  },
  methods: {
    isRequired(value) {
       return value !== null && value !== undefined && String(value).trim() !== '';
    },
    isMaxLength(value, maxLength) {
      return value.length <= maxLength;
    },
    isNumeric(value) {
      return /^[0-9]+$/.test(value);
    },
    isAlphanumeric(value) {
      return /^[a-zA-Z0-9]+$/.test(value);
    },
    isPhoneNumber(value) {
      return /^\d{10,11}$/.test(value);
    },
    isEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) && value.length <= 50;
    },
    isTwoDigitRegionID(value) {
      return /^\d{2}$/.test(value);  // 2桁の数字のみを許可
    },
    validateForm() {
      this.errors = {}; // エラーメッセージを初期化
      const fields = [
		{
          key: 'gyouseiId',
          value: this.newAdmin.gyouseiId,
          label: '行政機関ID',
          isRequired: true,
          maxLength: 5,
          additionalCheck: this.isAlphanumeric,
          errorMessage: '行政機関IDは英数字のみで入力してください',
        },
        {
          key: 'gyouseiName',
          value: this.newAdmin.gyouseiName,
          label: '行政機関名',
          isRequired: true,
          maxLength: 32
        },
      ];

      fields.forEach(({ key, value, label, isRequired, maxLength, additionalCheck, errorMessage }) => {
        if (isRequired && !this.isRequired(value)) {
          this.errors[key] = `${label}は必須項目です`;
        } else if (maxLength && !this.isMaxLength(value, maxLength)) {
          this.errors[key] = `${label}は${maxLength}文字以内で入力してください`;
        } else if (additionalCheck && !additionalCheck(value)) {
          this.errors[key] = errorMessage;
        }
      });

      return Object.keys(this.errors).length === 0; // エラーがない場合はtrue
    },
    validateAndRegister() {
      if (this.validateForm()) {
        this.register();
      } else {
        // バリデーションエラーがある場合にポップアップで警告を表示
        alert('入力エラーがあります');
      }
    },
    resetForm() {
	  this.region_id = '';
	  this.group_id = '';
      this.newAdmin = {
        region_id: '',
        gyouseiId: '',
        gyouseiName: '',
        managerDepart: '',
        managerName: '',
        managerTell: '',
        managerMail: '',
        gyouseiZyusho: '',
        gyouseiKbn: '市区町村',
        gyouseiZyusho: '',
        agencyIdCount: '0',
        agencyIdStatus: '無効',
        hunterIdCount: '0',
        hunterIdStatus: '無効',
        mieruAdminCount: '0',
        mieruAdminStatus: '無効',
        mieruMemberCount: '0',
        mieruMemberStatus: '無効',
        creatorId: '',
      };
    },
    async getRegionDetails() {
      const token = localStorage.getItem("jwtToken");
      const userId = localStorage.getItem("userId");

      try {
        // リクエストボディに id を含める
        const requestData = { id: userId };

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/regionSearch/getList`,
          requestData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
          this.regions = response.data.data;
        } else {
        	alert("不明なエラーです");
        }
      } catch (error) {
        alert("タイムアウトです、ログインしなおしてください");
        this.$router.push({ name: 'Login' });
      }
    },
    async register() {
      // JWTトークンを取得
      const token = localStorage.getItem("jwtToken");
      const userId = localStorage.getItem("userId");

      try {
        // サーバーに送信するデータ
        const requestData = {
          region_id: this.newAdmin.region,
          gyouseiId: this.newAdmin.gyouseiId,
          gyouseiName: this.newAdmin.gyouseiName,
          managerDepart: this.newAdmin.managerDepart,
          managerName: this.newAdmin.managerName,
          managerTell: this.newAdmin.managerTell,
          managerMail: this.newAdmin.managerMail,
          gyouseiKbn: this.newAdmin.gyouseiKbn === '国' ? 0 : 
                      this.newAdmin.gyouseiKbn === '都道府県' ? 1 : 
                      this.newAdmin.gyouseiKbn === '市区町村' ? 2 : null,
          gyouseiZyusho: this.newAdmin.gyouseiZyusho,
          agencyIdCount: this.newAdmin.agencyIdCount,
          agencyIdStatus: this.newAdmin.agencyIdStatus === '有効' ? 1 : 0,
          hunterIdCount: this.newAdmin.hunterIdCount,
          hunterIdStatus: this.newAdmin.hunterIdStatus === '有効' ? 1 : 0,
          mieruAdminCount: this.newAdmin.mieruAdminCount,
          mieruAdminStatus: this.newAdmin.mieruAdminStatus === '有効' ? 1 : 0,
          mieruMemberCount: this.newAdmin.mieruMemberCount,
          mieruMemberStatus: this.newAdmin.mieruMemberStatus === '有効' ? 1 : 0,
          kana: this.newAdmin.kana,
          creatorId: userId,
        };

        console.log("送信データ:", requestData); // デバッグ用
        // APIリクエスト送信
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/addminAgencyRegister/register`,
          requestData,
          {
            headers: {           
              Authorization: `Bearer ${token}`, // JWTトークンを送信
            },
          }
        );

        // ステータスコード200の場合（送信成功）
        if (response.status === 201) {
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
          alert("データが正常に登録されました");

          // 必要に応じてフォームのリセットや画面遷移を実行
          this.resetForm();
        } else if (response.status === 202) {
          alert("既に登録済みです");
        } else {
          alert("不明なエラーです");
		}
      } catch (error) {
        alert("タイムアウトです、ログインしなおしてください");
        this.$router.push({ name: 'Login' });
      }
	  this.btnoff = true;
    },
  },
};
</script>

<style scoped>
.usual { background-color: #17a2b8; }
.first { background-color: #28a745; }
.alert { background-color: #ff6347; }
.second { background-color: #6c757d; }
</style>
